module.exports = __webpack_public_path__ + "img/p2-68.fec116e4.png";